if (!customElements.get('collection-slider')) {
  class CollectionSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.collection-slider-track');
      // Collect ALL prev/next buttons (desktop header + mobile below-slider)
      this.btnsPrev = Array.from(this.querySelectorAll('.js-prev'));
      this.btnsNext = Array.from(this.querySelectorAll('.js-next'));

      this.init();
    }

    init() {
      if (!this.track) return;

      this.btnsNext.forEach(btn => btn.addEventListener('click', () => this.scroll('next')));
      this.btnsPrev.forEach(btn => btn.addEventListener('click', () => this.scroll('prev')));

      this.track.addEventListener('scroll', () => {
        this.updateProgress();
        this.updateButtons();
      });

      this.initDragToScroll();

      this.updateProgress();
      this.updateButtons();

      window.addEventListener('resize', () => {
        this.updateProgress();
        this.updateButtons();
      });
    }

    initDragToScroll() {
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.isDragging = false;

      this.track.addEventListener('mousedown', (e) => {
        this.isDown = true;
        this.isDragging = false;
        this.startX = e.pageX - this.track.offsetLeft;
        this.scrollLeft = this.track.scrollLeft;
      });

      this.track.addEventListener('mouseleave', () => {
        this.isDown = false;
        this.track.classList.remove('is-dragging');
      });

      this.track.addEventListener('mouseup', () => {
        this.isDown = false;
        setTimeout(() => {
          this.track.classList.remove('is-dragging');
        }, 0);
      });

      this.track.addEventListener('mousemove', (e) => {
        if (!this.isDown) return;
        
        const x = e.pageX - this.track.offsetLeft;
        const walk = (x - this.startX) * 1.5; // Scroll speed
        
        if (Math.abs(walk) > 5) {
          this.isDragging = true;
          this.track.classList.add('is-dragging');
          e.preventDefault();
        }
        
        if (this.isDragging) {
          this.track.scrollLeft = this.scrollLeft - walk;
        }
      });

      this.track.addEventListener('click', (e) => {
        if (this.isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    scroll(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;

      const cardWidth = card.offsetWidth;
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const scrollAmount = cardWidth + gap;

      this.track.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }

    /**
     * Progress bar logic:
     * - At scroll = 0 and N cards visible out of T total,
     *   the filled width = (N / T) * 100% of the progress track.
     * - As you scroll right, the fill increases until 100% when fully scrolled.
     * - The bar sits inside .collection-slider-progress which is a full-width
     *   track below the cards area.
     */
    updateProgress() {
      const progressBar = this.querySelector('.collection-slider-progress-bar');
      if (!progressBar) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      // How many cards are visible at once vs total
      const cards = this.track.querySelectorAll('.collection-card');
      const totalCards = cards.length;

      if (totalCards === 0) return;

      if (maxScroll <= 0) {
        // All cards fit – full bar
        progressBar.style.width = '100%';
        return;
      }

      // Visible cards count = track width / (card width + gap)
      const gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
      const cardWidth = (cards[0].offsetWidth + gap);
      const visibleCards = this.track.clientWidth / cardWidth;

      // At position 0: fill = visibleCards / totalCards
      // At max scroll: fill = 100%
      const baseWidth = (visibleCards / totalCards) * 100;
      const scrolledExtra = (this.track.scrollLeft / maxScroll) * (100 - baseWidth);
      const pct = Math.min(100, baseWidth + scrolledExtra);

      progressBar.style.width = `${pct}%`;
    }

    updateButtons() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 0;
      const atEnd = Math.ceil(this.track.scrollLeft) >= maxScroll - 1;

      this.btnsPrev.forEach(btn => { btn.disabled = atStart; });
      this.btnsNext.forEach(btn => { btn.disabled = atEnd; });
    }
  }

  customElements.define('collection-slider', CollectionSlider);
}
